<template>
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon" v-if="icon">
        <i :class="icon"></i>
      </div>
      <div class="header-text">
        <h1>{{ title }}</h1>
        <p v-if="subtitle">{{ subtitle }}</p>
      </div>
      <div class="header-actions" v-if="$slots.actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  title: string;
  subtitle?: string;
  icon?: string;
}>(), {
  subtitle: '',
  icon: ''
});
</script>

<style scoped>
.page-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 20px;
  /* Flat tenant secondary: in-page containers carry no gradient or shadow (DESIGN.md) */
  background: var(--app-secondary-color);
  border-radius: 12px;
  padding: 28px 32px;
}

.header-icon {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.header-icon i {
  font-size: 32px;
  color: #ffffff;
}

.header-text {
  flex: 1;
}

.header-text h1 {
  margin: 0 0 6px 0;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.5px;
}

.header-text p {
  margin: 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 15px;
  font-weight: 400;
}

/* O cabeçalho é pintado com a cor secundária da marca, a mesma que o tema dá ao texto
   do botão secundário: sem isto, o botão fica invisível aqui. */
.header-actions :deep(.p-button.p-button-secondary:not(.p-button-outlined)),
.header-actions :deep(.p-button.p-button-secondary.p-button-outlined) {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
}

.header-actions :deep(.p-button.p-button-secondary:not(.p-button-outlined):hover),
.header-actions :deep(.p-button.p-button-secondary.p-button-outlined:hover) {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Responsive */
@media (max-width: 768px) {
  .header-content {
    padding: 20px;
    flex-direction: column;
    text-align: center;
  }

  .header-icon {
    width: 48px;
    height: 48px;
  }

  .header-icon i {
    font-size: 24px;
  }

  .header-text h1 {
    font-size: 22px;
  }

  .header-actions {
    width: 100%;
  }
}
</style>
